import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { boFetch } from "@/lib/backoffice.server";

export const sendContactMessage = createServerFn({ method: "POST" })
  .inputValidator((input) =>
    z
      .object({
        fullName: z.string().trim().min(2).max(120),
        email: z.string().trim().email().max(180),
        phone: z.string().trim().max(40).optional().default(""),
        message: z.string().trim().min(10).max(4000),
        marketingConsent: z.boolean().optional(),
      })
      .parse(input),
  )
  .handler(async ({ data }) => {
    await boFetch("/api/public/v1/contact", {
      method: "POST",
      body: { ...data, marketingConsent: data.marketingConsent === true },
    });
    return { ok: true };
  });
